import { createFileRoute } from '@tanstack/react-router'
import CalcStatusView from '@navigator/CalcStatus'

export const Route = createFileRoute('/_auth/calcstatus')({
  component: RouteComponent,
})

function RouteComponent() {
  return <CalcStatusView />
}
